import * as h from 'h'

import ProfilePicture from 'components/ProfilePicture'

import styles from './styles.scss'

export default ({ faculties }) => {
  if (faculties === undefined || faculties.length === 0) {
    return null
  }

  return h.ul(h.ca(styles.container),
    faculties.map(f => (
      h.li({ key: f.name },
        h.h(ProfilePicture, {
          faculty: f,
          theme: {
            container: styles.avatar
          }
        }),
        h.div(h.ca(styles.text),
          h.span(h.ca(styles.name),
            h.l({to: `/faculty/${f.lincusAuthorId}`}, f.name)),
          h.br(),
          h.span(h.ca(styles.department),
            f.department.name))))))
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/FacultyList/index.js